import { configureStore, combineReducers } from "@reduxjs/toolkit";
import accountListReducer from "../features/accountListSlice";
import authReducer from "./authRedux";
import apiReducer from "./apiRedux";
import filterReducer from "./filterSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  api: apiReducer,
  filter: filterReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  accountList: accountListReducer,
});
